import { OverSeaAvatarUrl, ChinaAvatarUrl } from '@constant/index';

/**
 * 用户在 xmpp 后台中的唯一 ID
 * https://iwiki.woa.com/pages/viewpage.action?
 * pageId=784307521#id-%E5%85%B3%E9%94%AE%E5%90%8D%E8%AF%8D%E4%BB%8B%E7%BB%8D-openid
 *
 * @export
 * @param {string} instanceId
 * @param {string} userId
 * @param {string} appid
 * @returns
 */
export function getOpenId(instanceId: string, userId: string, appid: string): string {
  return `${instanceId}_${userId}_${appid}`;
}

export function getAvatarUrlByToken({
  avatarToken,
  userDistrict,
}: {
  avatarToken: string;
  userDistrict: string;
}): string {
  const avatarHost = Number.parseInt(userDistrict, 10) === 1 ? OverSeaAvatarUrl : ChinaAvatarUrl;
  return `${avatarHost}/${avatarToken}/small`;
}
